import type { LegacySlice } from "@prismicio/types-internal/lib/customtypes"

import { defaultImageContentWidget } from "./defaults"

/**
 * maybeResetSliceWidget
 *
 * @returns the default value for given a legacy slice widget
 */
interface MaybeResetSliceWidgetArgs {
  field: LegacySlice
}

/**
 * @description Legacy slices depend on default values within their widget. Since some components will clear state when emptied, we need to swap the emptied response (`undefined`) with a default widget value.
 * @returns default value of a widget for a legacy slice.
 */
export function maybeResetSliceWidget(args: MaybeResetSliceWidgetArgs) {
  const { field } = args

  if (field.type === "Image") return defaultImageContentWidget

  return undefined
}
